<template>
  <div class="container authorization">
    <v-row>
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-form ref="form" @submit.prevent="editRider">
            <v-card-title>
              <span class="headline">{{ $t("riders.edit_rider") }}</span>
            </v-card-title>
            <v-card-text>
              <v-row no-gutters class="mt-2">
                <v-col md="6" sm="6" cols="12" class="pb-0 pr-1">
                  <v-text-field
                    v-model="form.fName"
                    :label="$t('riders.first_name')"
                    disabled
                    outlined dense
                  ></v-text-field>
                </v-col>
                <v-col md="6" sm="6" cols="12" class="pb-0 pt-0">
                  <v-text-field
                    v-model="form.lName"
                    :label="$t('riders.last_name')"
                    disabled outlined dense
                  ></v-text-field>
                </v-col>
                <v-col md="12" cols="12" class="pb-0 pt-0">
                  <v-select 
                    outlined dense
                    v-model="form.relationship"
                    :items="itemsRelationshipOptions"
                    :label="$t('riders.relationship')"
                    :no-data-text="$t('common.no_data')"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn 
                @click="close"
                :color="`${buttonColor}`"
                class="btn mb-2"
                >{{ $t("riders.cancel") }}</v-btn>
              <v-btn
                type="submit"
                :color="`${buttonColor}`"
                class="btn mb-2"
              >{{ $t("riders.save") }}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-col md="12" cols="12" v-if="!loadingPage">
          <WarningAlert>
            <p class="mb-0">{{ $t("authorization.content_1") }}</p>
            <p class="mb-0">{{ $t("authorization.content_2") }}</p>
            <p class="mb-0">{{ $t("authorization.content_3") }}</p>
          </WarningAlert>
          <WarningProfileMinor v-if="!age18" />
      </v-col>
      <v-col md="12" cols="12" class="text-right pt-0 pb-0" >
        <v-btn :color="`${buttonColor}`" dark class="mb-2 btn_xs_rsp" @click="addPart">
          {{ $t("authorization.add_rider")}}
        </v-btn>
      </v-col>
      <v-col md="12" cols="12" class="pt-0">
        <v-data-table
          :headers="ridersHeaders"
          :items="myAccManItems"
          class="elevation-1"          
          dense
          :loading="loadingData"
          :loading-text="$t('yourRegistration.loading_text')"
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"
          :no-data-text="$t('dataTable.noDataText')"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
        >
          <template v-slot:top>     
            <v-dialog v-model="dialogDelete" max-width="600px">
              <v-card>
                <v-card-title class="headline">{{ $t('authorization.delete_rider') }}</v-card-title>
                <v-card-text>
                  <p class="mt16">{{ $t('authorization.sure_delete') }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn class="btn mb-2 mr-2" :color="`${buttonColor}`" @click="closeDelete('ri')">{{ $t('riders.cancel') }}</v-btn>
                  <v-btn
                      :color="`${buttonColor}`"
                      class="btn mb-2"
                      @click="deleteItemConfirm('ri')"
                    >{{ $t('riders.delete') }}</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:[`item.relationship`]="{ item: { relationship } }">
            {{ getTranslateRelationship(relationship) }}
          </template>
          <template v-slot:[`item.status`]="{ item: { status } }">
            {{ getTranslateStatus(status) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon v-if="item.isEdit" small class="mr-2" @click="editItem(item, 'ri')">fa far fa-pencil-alt</v-icon>
            <v-icon v-if="item.isEdit" small @click="deleteItem(item, 'ri')">fa far fa-trash-alt</v-icon>
          </template>
        </v-data-table>
      </v-col>
      <v-col md="12" cols="12" class="pb-0" v-if="!loadingPage && age18">
        <WarningAlert>
          <p class="mb-0">{{ $t("authorization.content_auth")}}</p>
          <p class="mb-0">{{ $t("authorization.content_auth_2")}}</p>
        </WarningAlert>
      </v-col>
      <v-col md="12" cols="12" v-if="age18">
        <v-data-table
          :headers="ridersHeaders"
          :items="yourAccManItems"
          class="elevation-1"
          dense
          :loading="loadingData"
          :loading-text="$t('dataTable.loading_text')"
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText')
          }"
          :no-data-text="$t('dataTable.noDataText')"
          :header-props="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
        >
          <template v-slot:top>
            <v-dialog v-model="dialogDeleteAM" max-width="600px">
                <v-card>
                  <v-card-title class="headline">{{ $t('authorization.delete_rider') }}</v-card-title>
                  <v-card-text>
                    <p class="mt16">{{ $t('authorization.sure_delete_am') }}</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn class="btn mb-2 mr-2" :color="`${buttonColor}`" @click="closeDelete('am')">{{ $t('authorization.btn_no') }}</v-btn>
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn mb-2"
                        @click="deleteItemConfirm('am')"
                      >{{ $t('authorization.btn_yes') }}</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
          </template>
          <template v-slot:[`item.relationship`]="{ item: { relationship } }">
            {{ getTranslateRelationship(relationship) }}
          </template>
          <template v-slot:[`item.status`]="{ item: { status } }">
            {{ getTranslateStatus(status) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon v-if="item.isEdit" small @click="deleteItem(item, 'am')">fa far fa-trash-alt</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
  </div>
</template>

<script>
import Snack from "../../components/notifications/Snack";
import RelationshipService from "../../services/RelationshipService";
import { VRow, VCol, VDataTable, VDialog, VCard, VSpacer, VIcon, VBtn,
         VCardTitle, VCardText, VCardActions, VForm, VTextField,
         VSelect } from 'vuetify/lib';
import { mapState } from 'vuex';
import WarningProfileMinor from "@/components/alert/WarningProfileMinor.vue";
import WarningAlert from "@/components/alert/WarningAlert";

export default {
  name: "Authorized",
  components: {
    Snack,
    VRow, VCol, VDataTable, VDialog, VCard, VSpacer, VIcon, VBtn,
    VCardTitle, VCardText, VCardActions, VForm, VTextField,
    VSelect,
    WarningProfileMinor,
    WarningAlert
  },
  data() {
    const ridersForm = Object.freeze({
      firstName: "",
      lastName: "",
      relationShip: ""
    });
    return {
      msg_snackbar: '',
      color_snackbar: '',
      snackbar: false,
      dialog: false,
      editedIndex: -1,
      dialogDelete: false,
      ridersForm,
      form: Object.assign({}, ridersForm),
      itemsRelationship: [],      
      myAccManItems: [],
      defaultItem: {
        firstName: "",
        lastName: "",
        relationShip: ""
      },
      userRoleId: 2,
      userRolePartId: 1,
      yourAccManItems: [],
      dialogDeleteAM: false,
      loadingData: true
    };
  },
  created(){
    this.showLinkedMembers();
    this.itemsRelationship_();
  },
  mounted() {
    this.$emit("titlePage", "riders.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
    this.$store.dispatch('setUserAction',{ forceUpdate: false, forceParticipants: false, disabledLoading: true });
  },
  updated() {},
  computed: {
    ridersHeaders(){
      return [
        {
          text: this.$t("authorization.livelaps_id"),
          align: "",
          sortable: true,
          value: "userId"
        },
        { text: this.$t("riders.email"), value: "email" },
        {
          text: this.$t("riders.first_name"),
          align: "",
          sortable: false,
          value: "fName"
        },
        { text: this.$t("riders.last_name"), value: "lName" },
        { text: this.$t("riders.relationship"), value: "relationship" },
        { text: this.$t("authorization.auth"), value: "status" },
        {
          text: this.$t("riders.actions"),
          value: "actions",
          sortable: false
        }
      ]
    },
    ...mapState({
      age18(state) {
        return state.session.age18
      },
      loadingPage: (state) => {
        if(state && state.session) return state.session.loadingPage;
        return true;
      }
    }),
    itemsRelationshipOptions() {
      return this.itemsRelationship.map((item) => {
        return {
          value: item,
          text: this.getTranslateRelationship(item)
        };
      });
  },
    buttonColor() { return this.$store.getters.env.get('VUE_APP_BUTTON_COLOR'); },
    borderAlertColor() { return this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR'); },
    iconAlertColor() { return this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR'); },
    bgAlertColor() { return this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR'); }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  methods: {
    addPart(){
      this.$router.push({
        path: "createAuthorization"
      }); 
    },
    itemsRelationship_(){
      RelationshipService.showRelationshipValues().then(response => {

        if(response.data.success == 1){
          // AMA Waiver Bypass v2: 'Other' is not selectable from self-
          // service relationship screens; only the waiver signing flow
          // exposes it (and locks the adult/minor pair when chosen).
          const values = Array.isArray(response.data.message) ? response.data.message : [];
          this.itemsRelationship = values.filter(v => String(v).toLowerCase() !== 'other');
        }
      });
    },
    async showLinkedMembers(){
      let myAccMan = [];
      await RelationshipService.getMyAccountManager().then(response => {
        if(response.data.success == 1){
          myAccMan = response.data.message;
        }
      });
      myAccMan.forEach(element => {
        element.isEdit = true;
        element.status = 'status'
        this.myAccManItems.push(element);
      });
      let yourAccMan = [];
      await RelationshipService.getYourAccountManager().then(response =>{
        if(response.data.success == 1){
          yourAccMan = response.data.message;
        }
      });
      this.yourAccManItems = yourAccMan.map((element) => {
        return {
          ...element, 
          isEdit: true,
          status: element.userRoleCode
        };
      });
      this.$store.dispatch('setLoadingPageAction',false);
      this.loadingData = false;
    },
    showSnackBar(msg, color){
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => this.snackbar = false, 3000);
    },
    editItem(item, _dt) {
      this.editedIndex = _dt == 'am' ? this.managerPartItems.indexOf(item) : this.myAccManItems.indexOf(item);      
      this.form = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item, _dt) {
      this.editedIndex = _dt == 'am' ? this.yourAccManItems.indexOf(item) : this.myAccManItems.indexOf(item);
      this.form = Object.assign({}, item);
      _dt == 'am' ? this.dialogDeleteAM = true : this.dialogDelete = true;
    },
    deleteItemConfirm(_dt) {
      _dt == 'am' ? this.yourAccManItems.splice(this.editedIndex, 1) : this.myAccManItems.splice(this.editedIndex, 1);
      this.closeDelete(_dt);
      RelationshipService.relationshipDelete(this.form.linkedMemberId).then(response => {

        if(response.data.success == 1){
          this.myAccManItems = [];
          this.yourAccManItems = [];
          this.showSnackBar(this.$t("riders.msg_success_deleted"), "success");
          this.showLinkedMembers();
        }

      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete(_dt) {
      _dt == 'am' ? this.dialogDeleteAM = false : this.dialogDelete = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    editRider() {
      let data = {};

      data.relId = this.form.linkedMemberId;
      data.relType = this.form.relationship;
      RelationshipService.relationshipUpdate(data).then(response => {

        if(response.data.success == 1){
          this.dialog = false;
          this.myAccManItems = [];
          this.managerPartItems = [];
          this.showSnackBar(this.$t("riders.msg_success_edited"), "success");
          this.showLinkedMembers();
        }

      });
     
    },
    getTranslateRelationship(relationship) {
      return relationship && this.$te("relationship." + relationship.toLowerCase()) ? 
              this.$t("relationship." + relationship.toLowerCase()) : '';
    },
    getTranslateStatus(status) {
      const index = (status || '').trim().replace(/\./g, '').replace(/\s+/g, '_').toLowerCase();
      return this.$te("authorization." + index) ? this.$t("authorization." + index) : '';
    }
  }
};
</script>

<style>
.authorization .v-data-table-header,
.authorization .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color:#fff !important;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}
@media (max-width: 599px) {
  .btn_bg, .btn_xs_rsp {
    max-width: 100%;
    min-width: auto !important;
    height: auto !important;
  }
  .btn_bg span, .btn_xs_rsp span {
    white-space: normal;
    max-width: 100%;
  }
  .btn_bg {
    min-height: 50px;
  }
  .btn_xs_rsp {
    min-height: 36px;
  }
  .v-snack__wrapper {
    min-width: 0px;
  }
}
</style>